module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }